import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import {
  BackgroundWrapper,
  UnifiedTextImageSlide,
  Breadcrumb,
  HeroSlider,
  ObjValidator,
} from "components";
import { useTranslate } from "hooks";

const ContentPage = Scrivito.connect(({ page }) => {
  const translate = useTranslate();
  const slides = page.get("slides") || [];
  const isBreadcrumbsHidden = page.get("breadCrumbs") === "No";
  const isLargePaddingsY = page.get("largePaddingsY") === "Yes";
  const isDarkBg = page.get("darkBg") === "Yes";

  return (
    <React.Fragment>
      {!isBreadcrumbsHidden && <Breadcrumb page={Scrivito.currentPage()} />}
      {slides.length === 1 && <UnifiedTextImageSlide slide={slides[0]} />}
      {slides.length > 1 && <HeroSlider slides={slides} />}
      <BackgroundWrapper
        page={page}
        classNames={cx({
          "py-8": isLargePaddingsY,
        })}
      >
        <div className="mb-6 ">
          <h1 className={isDarkBg ? "text-white" : null}>
            {translate("WELCOME_PAGE_TITLE")}
          </h1>
          <div className="row">
            <div
              className={cx(
                { "text-gray-400": isDarkBg },
                "font-md col-md-9 d-flex flex-column gap-3",
              )}
              data-testid="body"
            >
              <div data-testid="welcome-body-text-part1">
                {translate("WELCOME_PAGE_BODY_TEXT_PART1")}
              </div>
              <div data-testid="welcome-body-text-part2">
                {translate("WELCOME_PAGE_BODY_TEXT_PART2")}
              </div>
            </div>
          </div>
        </div>
        <Scrivito.ContentTag
          className="content-widgets"
          content={page}
          attribute="contentWidgets"
          tag="div"
        />
      </BackgroundWrapper>
    </React.Fragment>
  );
});

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ContentPage {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ContentPage", CheckedPage);
